import { Link } from 'react-router-dom';
import _unescape from 'lodash/unescape';

import useTranslation from 'hooks/useTranslation';

import { MassMessage, EntityRef } from 'models';

import { customFormat, toDate } from 'utils';
import styled from 'shared/utils/styled';

import {
  InfoList,
  InfoRow,
  InfoLabel,
  InfoValue,
} from 'components/styled-components';

const StyledLink = styled(Link)(() => ({
  color: '#224060',
}));

interface MassMessageGeneralInfoProps {
  massMessageData: MassMessage;
}

const MassMessageGeneralInfo = ({
  massMessageData,
}: MassMessageGeneralInfoProps) => {
  const { t } = useTranslation();

  const {
    CreatedOn,
    Cooperative,
    EventInformation,
    EventInformationUrl,
    ModifiedOn,
  } = massMessageData;

  const showEventInformationLink = !!EventInformation && !!EventInformationUrl;

  return (
    <InfoList>
      <InfoRow>
        <InfoLabel>
          {t('##attribute#uds_communicationmessage#uds_cooperativeid')}
        </InfoLabel>
        <InfoValue>{Cooperative?.Name ?? null}</InfoValue>
      </InfoRow>
      <InfoRow>
        <InfoLabel>
          {t('##attribute#uds_communicationmessage#uds_eventinformation')}
        </InfoLabel>
        {showEventInformationLink && (
          <InfoValue>
            <StyledLink
              to={`/board-eventsinformation/${
                (EventInformation as EntityRef).Id
              }`}
            >
              {_unescape((EventInformation as EntityRef).Name ?? '')}
            </StyledLink>
          </InfoValue>
        )}
      </InfoRow>
      <InfoRow>
        <InfoLabel>
          {t('##attribute#uds_communicationmessage#modifiedon')}
        </InfoLabel>
        <InfoValue>{customFormat(toDate(ModifiedOn), 'datetime')}</InfoValue>
      </InfoRow>
      <InfoRow>
        <InfoLabel>
          {t('##attribute#uds_communicationmessage#createdon')}
        </InfoLabel>
        <InfoValue>{customFormat(toDate(CreatedOn), 'datetime')}</InfoValue>
      </InfoRow>
    </InfoList>
  );
};

export default MassMessageGeneralInfo;
